import React from 'react';
import { Card, Typography, Link, Box } from '@mui/material';

const NewsCard = ({ title, excerpt, image, url }) => {
  const isMobile = window.innerWidth < 600;
  const width = isMobile ? '95vw' : '27vw';
  const maxHeight = 330;
  const height = isMobile ? `calc(95vw * 9 / 16)` : `min(${maxHeight}px, calc(27vw * 9 / 16))`;
  const isPlaceholderImage = image === 'https://via.placeholder.com/150';

  return (
    <Card
      style={{
        width: width,
        height: height,
        margin: '10px auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        backgroundColor: 'white',
        backgroundImage: !isPlaceholderImage ? `url(${image})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Link href={url} target="_blank" rel="noopener" underline="none" style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            width: '100%',
            padding: '10px',
            textAlign: 'center',
            fontWeight: 'bold',
            color: 'black',
            textShadow: '2px 2px 4px #FFF, -2px -2px 4px #FFF, 2px -2px 4px #FFF, -2px 2px 4px #FFF',
          }}
        >
          <Typography variant="h5" component="div" style={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
        </Box>
        {isPlaceholderImage && (
          <Box
            sx={{
              width: '100%',
              padding: '10px',
              color: 'black',
              textAlign: 'left',
              overflow: 'hidden',
              flexGrow: 1,
            }}
          >
            <Typography variant="body2" color="textSecondary" component="div">
              <span dangerouslySetInnerHTML={{ __html: excerpt }} />
            </Typography>
          </Box>
        )}
      </Link>
    </Card>
  );
};

export default NewsCard;
